<template>
  <a-dialog name="terms_of_service">
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      <terms-of-service></terms-of-service>
    </div>
  </a-dialog>
</template>

<script>
import TermsOfService from '@/views/Common/Documents/TermsOfService'

export default {
  name: 'TermsOfServiceDialog',
  components: { TermsOfService },
}
</script>

<i18n>
{
	"en": {
		"title": "Terms of Service"
	},
	"es": {
		"title": "Condiciones de uso"
	},
	"fr": {
		"title": "Conditions Générales d'Utilisation"
	},
	"it": {
		"title": "Condizioni di utilizzo"
	},
	"pt": {
		"title": "Condições de Utilização"
	},
	"pl": {
		"title": "Warunki korzystania z usługi"
	}
}
</i18n>
